<template>
  <div
    class="race-player-info-section"
    :class="`race-player-info-section--${screenOrientationType}`"
  >
    <div class="race-player-info-section__inner">
      <button type="button" class="race-player-info-section__selector" @click="emitPlayerChange">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.2374 2.17687L15.0607 7.00009H12.9393L9.17679 3.23753C9.07915 3.1399 8.92086 3.1399 8.82323 3.23753L5.06067 7.00009H2.93935L7.76257 2.17687C8.44599 1.49345 9.55403 1.49345 10.2374 2.17687ZM7.76255 15.8233L2.93933 11.0001H5.06065L8.82321 14.7627C8.92085 14.8603 9.07914 14.8603 9.17677 14.7627L12.9393 11.0001H15.0607L10.2374 15.8233C9.55401 16.5067 8.44597 16.5067 7.76255 15.8233Z"
            fill="white"
          />
        </svg>
      </button>

      <player-card-parts
        class="race-player-info-section__card"
        :img="playerPictureUrl(selectedPlayer)"
        :name="playerName(selectedPlayer)"
        @click="emitPlayerChange"
      />

      <div class="race-player-info-section__button-set">
        <button
          type="button"
          class="race-player-info-section__voice-switch"
          :class="{ 'race-player-info-section__voice-switch--selected': radioVoiceEnabled }"
          @click="toggleRadioVoice"
        >
          <svg
            ref="radioCountIcon"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M6.5 0H8V5H6.5V0Z" fill="white" />
            <path d="M9.5 4H12V5H9.5V4Z" fill="white" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5 7C5 6.44772 5.44772 6 6 6H12C12.5523 6 13 6.44772 13 7V17C13 17.5523 12.5523 18 12 18H6C5.44772 18 5 17.5523 5 17V7ZM6.5 7.5H11.5V8.5H6.5V7.5ZM11.5 9.5H6.5V10.5H11.5V9.5ZM7.5 13C7.5 13.2761 7.27614 13.5 7 13.5C6.72386 13.5 6.5 13.2761 6.5 13C6.5 12.7239 6.72386 12.5 7 12.5C7.27614 12.5 7.5 12.7239 7.5 13ZM9 13.5C9.27614 13.5 9.5 13.2761 9.5 13C9.5 12.7239 9.27614 12.5 9 12.5C8.72386 12.5 8.5 12.7239 8.5 13C8.5 13.2761 8.72386 13.5 9 13.5ZM11.5 13C11.5 13.2761 11.2761 13.5 11 13.5C10.7239 13.5 10.5 13.2761 10.5 13C10.5 12.7239 10.7239 12.5 11 12.5C11.2761 12.5 11.5 12.7239 11.5 13ZM7 15.5C7.27614 15.5 7.5 15.2761 7.5 15C7.5 14.7239 7.27614 14.5 7 14.5C6.72386 14.5 6.5 14.7239 6.5 15C6.5 15.2761 6.72386 15.5 7 15.5ZM9.5 15C9.5 15.2761 9.27614 15.5 9 15.5C8.72386 15.5 8.5 15.2761 8.5 15C8.5 14.7239 8.72386 14.5 9 14.5C9.27614 14.5 9.5 14.7239 9.5 15ZM11 15.5C11.2761 15.5 11.5 15.2761 11.5 15C11.5 14.7239 11.2761 14.5 11 14.5C10.7239 14.5 10.5 14.7239 10.5 15C10.5 15.2761 10.7239 15.5 11 15.5Z"
              fill="white"
            />
          </svg>
          <span class="race-player-info-section__voice-switch__count">{{
            getCurrentSelectedPlayerRadioDataSet.length
          }}</span>
        </button>

        <button
          type="button"
          class="race-player-info-section__race-select"
          :class="{ 'race-player-info-section__race-select--selected': raceSelectEnabled }"
          @click="toggleRaceSelect"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 3H3.78078C3.32191 3 2.92193 3.3123 2.81063 3.75746L2 7H6.21922C6.67809 7 7.07807 6.6877 7.18937 6.24254L8 3Z"
              fill="white"
            />
            <path
              d="M18 3H13.7808C13.3219 3 12.9219 3.3123 12.8106 3.75746L12 7H16.2192C16.6781 7 17.0781 6.6877 17.1894 6.24254L18 3Z"
              fill="white"
            />
            <path
              d="M6 11H1.78078C1.32191 11 0.921926 11.3123 0.810634 11.7575L0 15H4.21922C4.67809 15 5.07807 14.6877 5.18937 14.2425L6 11Z"
              fill="white"
            />
            <path
              d="M16 11H11.7808C11.3219 11 10.9219 11.3123 10.8106 11.7575L10 15H14.2192C14.6781 15 15.0781 14.6877 15.1894 14.2425L16 11Z"
              fill="white"
            />
            <path
              d="M12 7H7.78078C7.32191 7 6.92193 7.3123 6.81063 7.75746L6 11H10.2192C10.6781 11 11.0781 10.6877 11.1894 10.2425L12 7Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from '@vue/composition-api'
import PlayerCardParts from '@/components/common/card/PlayerCardParts.vue'
import StoreUtil from '@/store/StoreUtil'
import PlayerDocument from '@/store/stores/collectionModule/documents/player/PlayerDocument'
import CloudFrontUtil from '@/util/aws/CloudFrontUtil'
import useRadio from '@/components/RaceVideoPage/hook/useRadio'
import I18n from '@/locales/I18n'
import DeviceInfo from '@/util/DeviceInfo'

/**
 * レース動画再生画面 選手情報セクションのコンポーネント
 */
export default defineComponent({
  name: 'RacePlayerInfoSection',
  components: {
    PlayerCardParts,
  },
  props: {
    /**
     * 無線音声 ON/OFFフラグ
     */
    radioVoiceEnabled: {
      type: Boolean,
      default: false,
    },
    /**
     * レース選択 開閉フラグ
     */
    raceSelectEnabled: {
      type: Boolean,
      default: false,
    },
    /**
     * 画面向き
     */
    screenOrientationType: {
      type: String,
      default: 'portrait-primary',
    },
    /**
     * 初期お気に入り選択フラグ
     */
    favoriteRacePlayerSelected: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const raceVideoPageStore = StoreUtil.useStore('RaceVideoPageStore')
    const { getCurrentSelectedPlayerRadioDataSet } = useRadio()

    /**
     * 選手顔写真のURL
     * @param player 選手情報
     */
    const playerPictureUrl = (player?: PlayerDocument) => {
      if (!player) {
        return ''
      }
      return CloudFrontUtil.getSignedUrl(player.playerPicture)
    }

    /**
     * 選手名
     * @param player 選手情報
     */
    const playerName = (player?: PlayerDocument) => {
      if (!player) {
        return ''
      }
      // アプリ横向きの場合、省略名を表示
      if (
        DeviceInfo.isCordova() &&
        (props.screenOrientationType === 'landscape-primary' ||
          props.screenOrientationType === 'landscape-secondary')
      ) {
        // スコアリングから選手マスタを登録する際、省略名英語には車両番号を登録していないため、言語設定に関わらずplayerShortName.jaを表示する
        // playerShortName.jaには「省略名（アルファベット3文字） #車両番号」が登録されている
        return player.playerShortName.ja ?? ''
      }
      return player.playerName[I18n.locale] ?? ''
    }

    /**
     * 無線のカウント変更時にアニメーションクラス追加削除
     */
    const radioCountIcon = ref<HTMLElement & SVGElement>()
    watch(
      () => getCurrentSelectedPlayerRadioDataSet.value,
      (radioDataSet, oldRadioDataSet) => {
        const playerId = radioDataSet.length ? radioDataSet[0].playerId : null
        const oldPlayerId = oldRadioDataSet.length ? oldRadioDataSet[0].playerId : null
        if (
          radioDataSet.length > 0 &&
          radioDataSet.length > oldRadioDataSet.length &&
          playerId === oldPlayerId
        ) {
          radioCountIcon.value?.classList.add('is-animation')
          setTimeout(() => {
            radioCountIcon.value?.classList.remove('is-animation')
          }, 1000)
        }
      },
    )

    return {
      selectedPlayer: raceVideoPageStore.selectedPlayer,
      playerPictureUrl,
      playerName,
      radioCountIcon,
      getCurrentSelectedPlayerRadioDataSet,
    }
  },
  methods: {
    toggleRadioVoice(): void {
      /**
       * 無線音声 ON/OFFボタンが押下されたことを通知する
       * @event toggleRadioVoice
       * @type boolean
       */
      this.$emit('radioVoiceToggle')
    },
    toggleRaceSelect(): void {
      /**
       * レース選択ボタンが押下されたことを通知する
       * @event toggleRaceSelect
       */
      this.$emit('raceSelectToggle')
    },
    emitPlayerChange(): void {
      /**
       * 選手選択変更ボタンが押下されたことを通知する
       * @event emitPlayerChange
       * @type boolean
       */
      this.$emit('playerChange')

      this.$emit('raceSelectToggle', 'off')
    },
  },
})
</script>

<style lang="scss" scoped>
@keyframes vibration-anim {
  0% {
    transform: translate(0, 0) rotateZ(0deg);
  }

  25% {
    transform: translate(2px, 2px) rotateZ(1deg);
  }

  50% {
    transform: translate(0, 2px) rotateZ(0deg);
  }

  75% {
    transform: translate(2px, 0) rotateZ(-1deg);
  }

  100% {
    transform: translate(0, 0) rotateZ(0deg);
  }
}

.race-player-info-section {
  width: 100%;
  height: 44px;
  background: $black80;

  &__inner {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    gap: min(2.13vw, 8px);
    height: 44px;
    width: min(100%, 375px);
    padding: 0 min(6.4vw, 24px);
    margin: 0 auto;
  }

  &__card {
    width: calc(100% - min(4.26vw, 16px) - 56px);
    max-width: calc(100% - min(4.26vw, 16px) - 56px);
    cursor: pointer;
  }

  &__selector,
  &__voice-switch,
  &__race-select {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    min-width: 28px;
    height: 28px;
    border-radius: 2px;

    svg {
      width: 18px;
      min-width: 18px;
    }
  }

  &__voice-switch {
    width: auto;
    padding: 0 2px;
    white-space: nowrap;
    color: #fff;

    &__count {
      display: inline-block;
      min-width: 22px;
      text-align: center;
      padding-right: 2px;
      @include fontSetTextMedium();
    }

    svg.is-animation {
      animation: vibration-anim 0.1s 8;
    }
  }

  &__button-set {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-end;
    gap: 15px;
  }

  &__voice-switch,
  &__race-select {
    &--selected {
      background: rgba($green-light, 20%);
      color: $green-light;

      svg path {
        fill: $green-light;
      }
    }
  }

  &--landscape-primary,
  &--landscape-secondary {
    .race-player-info-section {
      &__inner {
        padding: 0 8px;
      }

      &__button-set {
        gap: 2px;
      }

      /** 英語の場合に、フルスクリーンの選手プルダウンの選手名が3行になる問題があったため、スタイルを変更 */
      &__card {
        width: calc(100% - 44px);
        max-width: calc(100% - 44px);
      }
    }
  }
}

@media screen and (max-width: 350px) {
  .race-player-info-section {
    &__button-set {
      gap: 10px;
    }
  }
}
</style>

<style lang="scss">
.race-player-info-section__card {
  .player-card-parts {
    &__img {
      img {
        width: 32px;
        height: 32px;
      }
    }

    &__data {
      width: calc(100% - 40px);

      &__name {
        color: $white;
        font-weight: 400;
        letter-spacing: 0.04em;
      }
    }
  }
}

@media screen and (max-height: 350px) {
  .race-player-info-section {
    &--landscape-primary,
    &--landscape-secondary {
      .race-player-info-section__inner {
        .race-player-info-section__selector {
          display: none;
        }

        .race-player-info-section__card {
          width: calc(100% - 32px);
          max-width: none;
        }
      }
    }
  }
}
</style>
